import React from 'react'
import ManageBooks from '../manage-books/ManageBooks'
import { ELibraryCategory } from '../../enum/elibrary_enum'
import { routeName } from '../../../../routes/routeName'
import { useTranslation } from 'react-i18next'

type Props = {}

const ManageEbooks = (props: Props) => {
    const { t } = useTranslation()
    return (
        <ManageBooks
            menu_name={t("จัดการE-Book")}
            category={ELibraryCategory.E_BOOK}
            path_create={routeName.e_library.manage_e_books_create}
            button_add_name={t("เพิ่มE-Book")}
            code='manage_e_books'
        />
    )
}

export default ManageEbooks